import React from 'react';
import { Loader } from 'lucide-react';
import NavigationButton from './NavigationButton';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';
import type { ActionButton } from '../../../services/chatService';

interface DynamicActionButtonProps {
  button: ActionButton;
  isLoading?: boolean;
  onClick: (button: ActionButton) => void;
}

const DynamicActionButton: React.FC<DynamicActionButtonProps> = ({
  button,
  isLoading = false,
  onClick,
}) => {
  const handleClick = () => {
    onClick(button);
  };

  // Handle navigation buttons specially
  if (button.action === 'generate_specific_navigation_button' && button.data) {
    return (
      <NavigationButton
        displayText={button.data.displayText || button.label}
        navigationPath={button.data.navigationPath}
        icon={button.data.icon}
        disabled={isLoading}
        isLoading={isLoading}
        onClick={handleClick}
      />
    );
  }

  // Handle all other action buttons with standard styling
  return (
    <Button
      onClick={handleClick}
      disabled={isLoading}
      variant="outline"
      size="sm"
      className={cn(
        'rounded-xl text-xs min-h-[32px]',
        'border-foreground/20 text-foreground/90',
        'hover:border-foreground/40 hover:bg-foreground/5',
        'disabled:border-foreground/10 disabled:text-foreground/30',
      )}
    >
      {isLoading && <Loader className="mr-2 h-3 w-3 animate-spin" />}
      {isLoading ? 'Processing...' : button.label}
    </Button>
  );
};

export default DynamicActionButton;
